export const minimumIOSMajorVersion = 16
export const minimumIOSMinorVersion = 4

// TODO: We should make these notifications relevant to the user's time.
// If it's 9am, we should send different generics.
export const kGenericNotificationPrompts = [
  'Ready to reflect on your day?',
  'What was the highlight of your day?',
  'What are you grateful for today?',
  'What did you learn today?',
  'What was challenging today?',
]
